import { Component, OnInit, HostListener } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { LandingComponent } from '../landing/landing.component';
import { TravelersService } from '../travelers/travelers.service';
// import { TravellersService } from './travellers.service';
import { LandingService } from '../landing/landing.service';
import { SwitchService } from '../switch/switch.service';
import { ErrorService } from '../error/error.service';
import { AppService } from '../../app.service';
import { DatalayerService } from '../../services/datalayer.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { UrlsModel } from '../travelers/travelers.model';
import { ActivateService } from '../../services/activate.service';
import { PaymentSelectionComponent } from '../eb/paymentSelection.component';
import { AuthService } from '@auth0/auth0-angular';
import { UtilService } from 'src/app/util.service';

@Component({
  selector: 'app-voucherSelector',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})
export class VoucherComponent implements OnInit {

  urls: UrlsModel;
  showBokrefFileds = true;
  showEuroBonusFileds = false;
  showDisabledLoginFields = false;
  alreadyLoggedInError = false;
  showErrorMsg = true;
  accountInfoCallCompleted = false;
  activateCallSuccess = false;
  activateCallCompleted = false;
  bookAndEuro = false;
  selectedDropdownType: string;
  public sasTnC: any;
  private subscription: Subscription;
  public urlType = 'pnr';
  public offerUrl = '';
  public showToggleButton = LandingComponent.showToggleButton;
  public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
  public buyMoreFlowForEB = PaymentSelectionComponent.buyMoreFlowForEB;
  public isCharterFlight = false;
  showSasTnC = false;
  public isSiteLogin: boolean;

  constructor(
    private travelersService: TravelersService,
    // private travellersService: TravellersService,
    private landingService: LandingService,
    private switchService: SwitchService,
    private errorService: ErrorService,
    private httpService: HttpService,
    private appService: AppService,
    private accessibilityService: AccessibilityService,
    private datalayerService: DatalayerService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private router: Router,
    private authService:AuthService,
    private utils: UtilService,
    private activateService: ActivateService) {
    this.showPnrFromSwitchSubscribe();
  }

  ngOnInit() {
    this.appService.hideLandingCustomer();
    this.appService.makecursorWorkFine();
    // this.urls = this.travelersService.getUrls();
    this.isCharterFlight = this.appService.getFlightServiceType();
    this.getTnCUrls();
    this.appService.removeScrollBody();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && (params.username)) {
        this.urlType = 'eb';
      } else {
        this.urlType = 'pnr';
      }
    });
    this.alreadyLoggedInErrorMethod();
    this.accessibilityService.setSkipLinkId('bookRefAc');
    this.appService.hideLoader();
    this.appService.hideLoaderWithText();
  }
  getTnCUrls() {
    const tncUrls = { sas: '' };
    const baseUrl = this.appService.getTncBaseUrl();
    this.translate.get(['sasTnC.text']).subscribe(result => {
      tncUrls.sas = baseUrl + result['sasTnC.text'];
      // this.travelersService.setTnCUrls(tncUrls);
    });
  }

  redirectToBuywifi() {
    this.appService.showLoader();
    this.closeVoucherConnectOverlay();
    this.router.navigate(['product']);
    this.errorService.removeError();
  }

  alreadyLoggedInErrorMethod() {
    // const alreadyLoginErrorCode = this.travelersService.getAlreadyLoginErrorCode();
    this.showDisabledLoginFields = false;
    // if (alreadyLoginErrorCode && alreadyLoginErrorCode !== '') {
    //   LandingComponent.showToggleButton = false;
    //   this.showToggleButton = false;
    // }
  }

  private showPnrFromSwitchSubscribe() {
    this.subscription = this.appService.showPnrFromSwitchObservable.subscribe(
      showEbLogin => {
        if (showEbLogin) {
          this.appService.hideLoader();
        }
      });
  }

  connectToWifiPnr() {
    const loaderTextList = { loaderHeaderText: 'loaderText' };
    this.appService.showLoaderWithText(loaderTextList);
    const pnrFormData = this.travelersService.getPnrFormData();
    const charterFormDataModel = this.travelersService.getCharterFormData();
    const getDeviceData = this.landingService.getGetDeviceResponse();
    const deviceName = this.landingService.getDeviceName();
    let activateRequest: any;
    if (this.isCharterFlight) {
     activateRequest = this.travelersService.activateCallRequestUrlForCharter(getDeviceData, pnrFormData, deviceName);
    } else {
      activateRequest = this.travelersService.activateCallRequestUrlForVoucher(getDeviceData, pnrFormData, deviceName);
    }

    if (!LandingComponent.showToggleButton) {
      this.isSiteLogin = JSON.parse(sessionStorage.getItem('loginsucess'));
      if (this.isSiteLogin && getDeviceData['status'].code !== 'FULL' && !LandingComponent.isbuyButtonTrigger) {
        this.doActivateCall(activateRequest, 'pnr');
        this.datalayerService.activateDataLayer('Connection attempt - Booking reference');
      } else {
        this.redirectbuywifiPage();
      }
    } else if (LandingComponent.showToggleButton || this.isCharterFlight) {
      this.doActivateCall(activateRequest, 'pnr');
      this.datalayerService.activateDataLayer('Connection attempt - Booking reference');
    }
  }

  connectToWifiLogin() {
    const loaderTextList = { loaderHeaderText: 'loaderText' };
    this.appService.showLoaderWithText(loaderTextList);

    if (PaymentSelectionComponent.showEBforPointsBuy) {
      // const pnrFormData = this.travelersService.getPnrFormData();
      // this.travellersService.setPassengerDetails(pnrFormData);
      // if (this.isCharterFlight) {
      //   if (pnrFormData != null) {
      //     // this.travellersService.getPointsOfferWithPaxId(pnrFormData.paxid);
      //   }
      //   else {
      //     const deviceDetails = this.appService.getDeviceResponse();
      //     // this.travellersService.getPointsOfferWithPaxId(deviceDetails.passenger.id);
      //   }
      // }
      // else {
      //   // this.travellersService.getPointsOffer();
      // }
    }
    else {
      const sessionId = this.appService.getSessionId();
      const getDeviceData = this.landingService.getGetDeviceResponse();
      const deviceName = this.landingService.getDeviceName();
      // const activateRequest = this.travelersService.activateCallRequestUrlForLogin(getDeviceData, sessionId, deviceName);
      // this.doActivateCall(activateRequest, 'login');
      this.datalayerService.activateDataLayer('Connection attempt - Eurobonus');
    }
  }

  doActivateCall(request, type) {
    //console.log('in activate call', request,type);
    this.activateService.doActivateCall(request).subscribe(
      activateResponse => {
        if (activateResponse.errors) {
          this.updateActivateErrorInfo(activateResponse, request, type);
          this.appService.scrollToActivateModel();
        } else if (activateResponse.status && activateResponse.status.code === 'FULL') {
          this.errorService.removeError();
          this.enableDisableViewBasedOnActivateResponse();
          this.actionBasedOnType(activateResponse, type);
        }
      },
      error => {
        this.activateCallCompleted = true;
        this.activateCallSuccess = false;
        this.errorService.addError(this.landingService.getDefaultError());
        if (type === 'pnr') {
          this.appService.hideLoader();
          this.appService.hideLoaderWithText();
        } else {
          this.logoutCustomer();
        }
      }
    )
  }
  enableDisableViewBasedOnActivateResponse() {
    this.activateCallSuccess = true;
    this.activateCallCompleted = true;
    LandingComponent.showVoucherLogin=false;
    LandingComponent.isDeviceActivated = true;
    LandingComponent.showLandingBanner = false;
    LandingComponent.showActivateScreen = false;
    LandingComponent.showSwitchScreen = false;
  }
  actionBasedOnType(activateResponse, type) {
    if (type === 'pnr') {
      this.datalayerService.activateDataLayer('Connection successful  - Booking reference');
    } else {
      this.datalayerService.activateDataLayer('Connection successful  - Eurobonus');
    }
  }
  updateActivateErrorInfo(activateResponse, request, type) {
    if (activateResponse.links) {
      this.appService.setPassengerIdData(activateResponse.links);
    }
    // Change for OWE-508
    if (activateResponse.connectionType === 'RESTRICTED') {
      this.datalayerService.postActivateDataLayerError('RESTRICTED');
    }
    // Change ends
    for (const error of activateResponse.errors) {
      if (error.errorCode === '7011016') {
        this.getDeciveTypeCall(activateResponse, request, type);
      } else if (error.errorCode === '7011012') {      
        this.openPaymentSelectionPage();
      } else {
        this.activateCallSuccess = false;
        if (error.errorCode.substring(0, 1) === '7') {
          const singleError = [];
          singleError.push(error);
          this.errorService.addError(singleError);
          if (type === 'login' && error.errorCode === '7011053') {
            this.logoutCustomer();
            this.showEuroBonusFileds = false;
            this.showBokrefFileds = true;
            this.showDisabledLoginFields = false;
            this.datalayerService.activateDataLayer('Select tab - Booking reference');
          }
        } else {
          const despError = [{ 'type': 'despOnly', 'desp': error.errorMessage }];
          this.errorService.addError(despError);
        }
        this.appService.hideLoaderWithText();
        this.activateCallCompleted = true;
        if (type === 'pnr') {
          this.datalayerService.activateDataLayer('Connection failed  - Booking reference');
        } else {
          this.datalayerService.activateDataLayer('Connection failed  - Eurobonus');
        }
      }
    }
  }

  getDeciveTypeCall(activateResponse, request, type) {
    for (const link of activateResponse.links) {
      if (link.rel === 'PassengerAssociatedDevices') {
        const loaderTextList = { loaderHeaderText: 'loaderText' };
        this.appService.showLoaderWithText(loaderTextList);
        this.errorService.removeError();
        const paxId = link.href.split('=')[1];
        // const getDeviceTypeRequest = this.travelersService.getDeviceTypesRequest(paxId);
        // this.httpService.getData(getDeviceTypeRequest).subscribe(
        //   deviceTypeResponse => {
        //     if (deviceTypeResponse.errors) {
        //       this.activateCallSuccess = false;
        //       this.errorService.addError(deviceTypeResponse.errors);
        //       if (type === 'pnr') {
        //         this.appService.hideLoaderWithText();
        //       } else {
        //         this.logoutCustomer();
        //       }
        //     } else {
        //       this.switchService.setConnectedCount(deviceTypeResponse);
        //       this.activateCallSuccess = true;
        //       this.switchService.setDataFromLanding(deviceTypeResponse, this.landingService.getGetDeviceResponse(), paxId);
        //       this.errorService.removeError();
        //       this.showBokrefFileds = true;
        //       this.showToggleButton = false;
        //       this.showEuroBonusFileds = false;
        //       LandingComponent.showToggleButton = false;
        //       LandingComponent.showActivateScreen = false;
        //       LandingComponent.showSwitchScreen = true;
        //     }
        //     this.activateCallCompleted = true;
        //   },
        //   error => {
        //     this.updateErrorResponse(type);
        //   }
        // )
      }
    }
  }

  updateErrorResponse(type) {
    this.activateCallSuccess = false;
    this.errorService.addError(this.landingService.getDefaultError());
    if (type === 'pnr') {
      this.appService.hideLoader();
    } else {
      this.logoutCustomer();
    }
    this.activateCallCompleted = true;
  }

  logoutCustomer() {
    this.appService.customerLogoutFromActivate();
    this.appService.hideLoaderWithText();
    this.authService.logout();
    this.utils.newEBUserLogout();
  }

  toggleButtonChange(value) {
    this.errorService.removeError();
    if (value === 'bref') {
      this.showEuroBonusFileds = false;
      this.showBokrefFileds = true;
      this.showDisabledLoginFields = false;
      this.datalayerService.activateDataLayer('Select tab - Booking reference');
    } else if (value === 'eb') {
      this.showEuroBonusFileds = true;
      this.showBokrefFileds = false;
      this.datalayerService.activateDataLayer('Select tab - Eurobonus');
      if (this.alreadyLoggedInError) {
        // const alreadyLoginErrors = this.travelersService.getAlreadyLoginErrors();
        // this.errorService.addError(alreadyLoginErrors);
        this.showDisabledLoginFields = true;
        this.showErrorMsg = true;
      }
    }
  }

  openSasTnC() {
    this.showSasTnC = true;
    this.accessibilityService.focus('#termsAndConClose');
  }



  closeVoucherConnectOverlay() {
    //console.log('CLose');
    this.appService.addScrollBody();
    this.errorService.removeError();
    this.appService.showLandingCustomer();
    this.appService.removeCustomerErrors();
    LandingComponent.showActivateScreen = false;
    LandingComponent.showVoucherLogin=false;
    this.appService.scrollToTop();
    this.accessibilityService.focus('#landing-connect');
    if (PaymentSelectionComponent.showEBforPointsBuy) {
      PaymentSelectionComponent.showEBforPointsBuy = false;
    }
  }



  keyEvent(event, id) {
    event.preventDefault();
    this.accessibilityService.focus(id);
  }

  tabFromActivateButton(event) {
    event.preventDefault();
    this.accessibilityService.focus('#activate-close');
  }

  redirectbuywifiPage() {
    const loaderTextList = { loaderHeaderText: 'loaderText' };
    // const pnrFormData = this.travelersService.getPnrFormData();
    const isCharter = this.appService.getFlightServiceType();
    // this.travellersService.setPassengerDetails(pnrFormData);
    this.appService.showLoaderWithText(loaderTextList);
    // if (isCharter) {
    //   this.travellersService.buildCharterAncillaryOffers();
    // } else {
    //   this.travellersService.buildAncillaryOffers();
    // }
  }

  openPaymentSelectionPage() {
    PaymentSelectionComponent.buyMoreFlowForEB = false;    
    this.closeVoucherConnectOverlay();
    LandingComponent.showPaymentSelectionScreen = true;
    this.errorService.removeError();
  }

  @HostListener('window:keydown', ['$event'])
  keyboardEventsHandling(event) {
    if ((event.key === 'Tab' && !event.shiftKey && (event.target.id === 'activate-header' || event.target.id === 'bookRefAc'))) {
      event.preventDefault();
      this.bookAndEuro = true;
    } else if ((event.key === 'Tab' && event.shiftKey && (event.target.id === 'activate-close'))) {
      event.preventDefault();
      this.accessibilityService.focus('#connect-btn');
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.accessibilityService.focus('#activate-close');
    } else {
      this.bookAndEuro = false;
    }
  }

}
// import { Component } from '@angular/core';
// import { LandingComponent } from '../landing/landing.component';
// import { ErrorService } from '../error/error.service';
// import { LandingService } from '../landing/landing.service';
// import { TravelersService } from '../travelers/travelers.service';
// import { TravellersService } from '../travelers/travellers.service';
// import { AppService } from '../../app.service';
// import { ONBOARD_CONSTANTS } from '../../app.constants';
// import { environment } from '../../../environments/environment';
// import { HttpService } from '../../services/http.service';
// import { ActivateService } from '../../services/activate.service'
// import {PnrFormDataModel} from '../travelers/travelers.model';
// import { BuywifiService } from '../../services/buywifi.service';
// import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { DatalayerService } from 'src/app/services/datalayer.service';

// @Component({
//   selector: 'app-voucherSelector',
//   templateUrl: './voucher.component.html',
//   styleUrls: ['./voucher.component.css']
// })
// export class VoucherComponent {

//   static showEBforPointsBuy = false;
//   static buyMoreFlowForEB = true; 
//   public isSiteLogin: boolean; 
//   showEmailErrorMsg = false;
//   voucherTopSet = false;
//   activateCallSuccess=false;
//   activateCallCompleted=false;
//   voucherForm: FormGroup;
//   regEx: RegExp;
//   public voucherCode: String;
//   public voucherError:String;
//   showVoucherError= false;
//   constructor(private errorService: ErrorService,
//     private fb: FormBuilder,
//     private landingService: LandingService,
//     private travelersService: TravelersService,
//     private travellersService: TravellersService,
//     private appService: AppService,
//     private httpService: HttpService,
//     private buywifiService: BuywifiService,
//     private activateService: ActivateService,
//     private datalayerService: DatalayerService) {
//   }

//   ngOnInit() {
//     this.voucherForm = this.fb.group({
//       'voucher': ['', [Validators.required,
//         Validators.pattern(this.regEx)]]
//     });
//   }
//   get voucher() {
//     return this.voucherForm.get('voucher');
//   }

//   closePaySelectionOverlay() {    
//     LandingComponent.showPaymentSelectionScreen = false;
   
//   }

//   onActiveVoucher() {
//     this.showEmailErrorMsg = false;
//     this.checkVoucherState('focused');
//   }

//   onBlurVoucher() {
//     this.voucherCodeValidation();
//     this.showEmailErrorMsg = true;
//     this.checkVoucherState('blur');
//   }


//   checkVoucherState(state) {
//     if (state === 'focused' || this.voucher.value) {
//       this.voucherTopSet = true;
//     } else {
//       this.voucherTopSet = false;
//     }
//   }
//   voucherCodeValidation() {
    
//     this.voucherCode= this.voucher.value;
//     if(this.voucherCode.length !=8 ) {
//       this.voucherError = "Please enter valid voucher code with 8 characters";
//       this.showVoucherError = true;
//     } else if(this.voucherCode.indexOf('0') != -1){
//       this.voucherError = "You have incorrectly entered zero instead of the alphabet character 'O'.";
//       this.showVoucherError = true;
//     } else {
//       this.showVoucherError=false;
//     }
//   }
//   voucherConnect() {
//     this.appService.showLoader();
//     this.voucherCodeValidation();
//     if(this.showVoucherError){
//       this.appService.hideLoader();
//       return false;
//     }
//     this.voucherCode= this.voucher.value;
//     const getDeviceData = this.landingService.getGetDeviceResponse();
//     let activateVoucherRequest = this.landingService.activateCallRequestForVoucher(getDeviceData,this.voucherCode);
//     this.activateService.doActivateCall(activateVoucherRequest).subscribe(activateResponse=> {
//       if (activateResponse.errors) {
//         this.errorService.addError(activateResponse.errors);
//         this.closeVoucherConnectOverlay();
//       } else if (activateResponse.status && activateResponse.status.code === 'FULL') {
//         this.errorService.removeError();
//         this.enableDisableViewBasedOnActivateResponse();
//         this.actionBasedOnType();
//         this.closeVoucherConnectOverlay();
//       }
//     }, 
//     error=>{
//       this.errorService.addError([{ 'errorCode': ONBOARD_CONSTANTS.DEFAULT_ERROR }]);
//       this.closeVoucherConnectOverlay();
//     });
//     this.appService.hideLoader();
//   }
//   actionBasedOnType() {
//       this.datalayerService.activateDataLayer('Connection successful  - Voucher');
   
//   }
//   enableDisableViewBasedOnActivateResponse() {
//     this.activateCallSuccess = true;
//     this.activateCallCompleted = true;
//     LandingComponent.isDeviceActivated = true;
//     LandingComponent.showLandingBanner = false;
//     LandingComponent.showActivateScreen = false;
//     LandingComponent.showSwitchScreen = false;
//   }
//   getPassengerRequest(paxId: any) {
//     const requestPassengerCall = {
//       url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_PASSENGER_PAXID.replace('<<passengerId>>', paxId)
//     };
//     return requestPassengerCall;
//   }

  

//   redirectToBuywifi() {
//   }
//  closeVoucherConnectOverlay() {
//     LandingComponent.showVoucherLogin = false;
  
//  }
// }
